import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

/**
 * Creates 32x32 plane gameobjects.
 * @param {HYPERCUBEJS.Material} [$material] The material to add.
 * @returns {HYPERCUBEJS.Node}
 */
function gameobjectplane32x32($material = HYPERCUBEJS.DEFAULTS.material()) {

    const plane32x32 = new HYPERCUBEJS.Node('plane32x32');
    const meshplane32x32 = new HYPERCUBEJS.MeshPlane('meshplane32x32', [32, 32]);

    meshplane32x32.setmaterial($material);
    plane32x32.addmesh(meshplane32x32);

    plane32x32.setcomponent('collideraabb', {

        'type': 'static',

        'min': [-16, 0, -16],
        'max': [16, 0, 16]
    });

    return plane32x32;
}

export {

    gameobjectplane32x32
};

export default gameobjectplane32x32;
